/**
 * App configuration — loads and validates VITE_ environment variables.
 */

export interface AppConfig {
  signalingUrl: string;
  chain: string;
  contractAddress: string;
  rpcUrl: string;
  rpcFallbackUrl: string;
  platformAddress: string;
  platformBps: number;
  affiliateBps: number;
}

export function loadAppConfig(): AppConfig {
  const signalingUrl = import.meta.env.VITE_SIGNALING_URL || `${window.location.protocol === 'https:' ? 'wss:' : 'ws:'}//${window.location.host}/ws`;
  const chain = import.meta.env.VITE_CHAIN || 'eip155:56';
  const contractAddress = import.meta.env.VITE_CONTRACT_ADDRESS || '0xb58d6b898AE8f45321ed7Fe84d7788c078be5022';
  const rpcUrl = import.meta.env.VITE_RPC_URL || 'https://bsc-dataseed1.binance.org';
  const rpcFallbackUrl = import.meta.env.VITE_RPC_FALLBACK_URL || 'https://bsc-dataseed2.binance.org';
  const platformAddress = import.meta.env.VITE_PLATFORM_ADDRESS || '0xc2214c3CE528c8561a72A2E16800Ebf84158E8F0';
  const platformBps = parseInt(import.meta.env.VITE_PLATFORM_BPS || '500', 10);
  const affiliateBps = parseInt(import.meta.env.VITE_AFFILIATE_BPS || '0', 10);

  return {
    signalingUrl,
    chain,
    contractAddress,
    rpcUrl,
    rpcFallbackUrl,
    platformAddress,
    platformBps,
    affiliateBps,
  };
}

let configInstance: AppConfig | null = null;

export function getAppConfig(): AppConfig {
  if (!configInstance) {
    configInstance = loadAppConfig();
  }
  return configInstance;
}
